import Cookies from 'js-cookie';
import Module from 'lib/module';
import Util, { ViewPort } from '../lib/util';

@Module.define('homeSlider')
class HomeSlider extends Module {
	constructor(options) {
		super(options);

		this.slideContainer = $('.js-hero-carousel');

		this.memberAlertsContainer = $('.js-member-alerts');
		this.removeSlide = $('.icon-close');

		this.memberSlideContainer = $('.js-member-hero-carousel');
		this.memberFeauteredItemContainer = $('.js-member-featured-item-carousel');
		this.playToggle = $('.js-carousel-toggle');
		this.next = $('.js-carousel-next');
		this.prev = $('.js-carousel-prev');
		this.isCarouselAutoplay = true;
		this.slideIndex = 0;
	}

	main() {
		const _this = this

		document.querySelector('.icon-pause').style.display = 'block';
		document.querySelector('.icon-play').style.display = 'none';
		this.carouselInit();
		this.initAlerts();
		this.initExpoCountdown();
	}

	bindEvents() {
		this.playToggle.on('click touch', e => this.carouselPlayToggle());
		this.next.on('click touch', e => this.memberFeauteredItemContainer.slick('slickNext'));
		this.prev.on('click touch', e => this.memberFeauteredItemContainer.slick('slickPrev'));

		this.removeSlide.on('click touch', e => this.handleRemoveAlert(e));

		$(window).on('resize', Util.debounce(e => this.onResize(e)));
	}
	onResize(e) {

	}

	carouselInit() {
		this.slideContainer.slick({
			//appendArrows: $('.js-arrow-target'),
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 970,
					settings: {
						arrows: false
					}
				}
			]

		});
		this.memberAlertsContainer.slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 7000,
			cssEase: 'linear',
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1
		});
		this.memberSlideContainer.slick({
			asNavFor: this.memberFeauteredItemContainer,
			arrows: false,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			useCSS: false,
			useTransform: false,
		});
		this.memberFeauteredItemContainer.slick({
			asNavFor: this.memberSlideContainer,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			cssEase: 'linear',
			dots: true,
			dotsClass: "js-carousel-pagination",
			draggable: false,
			fade: true,
			slidesToShow: 1,
			slidesToScroll: 1
		});
	}

	initAlerts() {
		const alertElements = document.querySelectorAll('[data-alert-id]');
		const alertIds = Array.from(alertElements, (element) => element.getAttribute('data-alert-id'));

		alertIds.forEach(id => {
			if (Cookies.get(id)) this.tryRemoveAlert(id);
		});

		this.tryRemoveContainer();
	}

	handleRemoveAlert(e) {
		const id = e.target.getAttribute('data-alert-id');

		this.tryRemoveAlert(id);

		Cookies.set(id, id, { expires: 7 });

		this.tryRemoveContainer();
	}

	tryRemoveAlert(id) {
		const alertElements = document.querySelectorAll('[data-alert-id]');
		const alertIds = Array.from(alertElements, (element) => element.getAttribute('data-alert-id'));

		const alertIndex = alertIds.indexOf(id);
		if (alertIndex === -1) return;

		this.memberAlertsContainer.slick('slickRemove', alertIndex);
    }

	tryRemoveContainer() {
		const slides = document.querySelectorAll(".alert");

		if (slides.length === 0) {
			document.querySelector(".member-alerts").style.display = "none";
		}
    }

	carouselPlayToggle() {
		const slickAction = this.isCarouselAutoplay ? 'slickPause' : 'slickPlay';

		this.slideContainer.slick(slickAction);
		this.memberFeauteredItemContainer.slick(slickAction);
		document.querySelector('.icon-pause').style.display = this.isCarouselAutoplay ? 'none' : 'block';
		document.querySelector('.icon-play').style.display = this.isCarouselAutoplay ? 'block' : 'none';
		this.isCarouselAutoplay = !this.isCarouselAutoplay;
	}

	initExpoCountdown() {
		const banner = document.querySelector('.member-expo-banner[data-countdown-to]');
		const countdownEl = document.querySelector('.js-expo-countdown');

		if (!banner || !countdownEl) return;

		const targetDate = new Date(banner.getAttribute('data-countdown-to'));
		if (isNaN(targetDate.getTime())) return;

		const pad = (n) => String(n).padStart(2, '0');

		const updateCountdown = () => {
			const remaining = targetDate.getTime() - Date.now();

			if (remaining <= 0) {
				banner.style.display = 'none';
				clearInterval(this.expoCountdownInterval);
				return;
			}

			const totalSeconds = Math.floor(remaining / 1000);
			const days = Math.floor(totalSeconds / 86400);
			const hours = Math.floor((totalSeconds % 86400) / 3600);
			const minutes = Math.floor((totalSeconds % 3600) / 60);
			const seconds = totalSeconds % 60;

			countdownEl.textContent = `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
		};

		updateCountdown();
		this.expoCountdownInterval = setInterval(updateCountdown, 1000);
	}
}

